// extracted by mini-css-extract-plugin
export default {"container":"gu6CGb4tbxZVsvKRPRW1","section":"UnanK6N4b63SFAvLTvn6","label":"POJkIArV13LY5BPX7O2Y","detail":"ovRm3innGMHr_syCBdGm"};